import { PARTNER_BANNER_OPTIONS, PARTNERS } from '@constants';
import GDLogo from '@assets/images/partner-logos/griddynamics.svg';
import AWSLogo from '@assets/images/partner-logos/aws.png';
import GCPLogo from '@assets/images/partner-logos/gcp.png';
import CommercetoolsLogo from '@assets/images/partner-logos/commercetools.svg';
import AlgoliaLogo from '@assets/images/partner-logos/algolia.png';
import MXPLogo from '@assets/images/partner-logos/mxp.png';
import ContentstackLogo from '@assets/images/partner-logos/contentstack.svg';
import CloudinaryLogo from '@assets/images/partner-logos/cloudinary.png';
import FluentcommerceLogo from '@assets/images/partner-logos/fluentcommerce.svg';
import MagellanLogo from '@assets/images/partner-logos/magellan.svg';
import KiboLogo from '@assets/images/partner-logos/kibo.png';

const partnersLogos = [ {
  partner: PARTNER_BANNER_OPTIONS.GRIDDYNAMICS,
  logo: GDLogo,
  url: 'https://www.griddynamics.com/',
},
{
  partner: PARTNER_BANNER_OPTIONS.AWS,
  logo: AWSLogo,
  url: 'https://aws.amazon.com/',
},
{
  partner: PARTNER_BANNER_OPTIONS.GCP,
  logo: GCPLogo,
  url: 'https://cloud.google.com/',
},
{
  partner: PARTNER_BANNER_OPTIONS.COMMERCETOOLS,
  logo: CommercetoolsLogo,
  url: 'https://commercetools.com/'
}, {
  partner: PARTNER_BANNER_OPTIONS.MXP,
  logo: MXPLogo,
  url: 'https://cloud.google.com/solutions/retail-product-discovery'
}, {
  partner: PARTNER_BANNER_OPTIONS.ALGOLIA,
  logo: AlgoliaLogo,
  url: 'https://www.algolia.com/',
},
{
  partner: PARTNER_BANNER_OPTIONS.CONTENTSTACK,
  logo: ContentstackLogo,
  url: 'https://www.contentstack.com/',
},
{
  partner: PARTNER_BANNER_OPTIONS.CLOUDINARY,
  logo: CloudinaryLogo,
  url: 'https://cloudinary.com/',
},
{
  partner: PARTNER_BANNER_OPTIONS.FLUENTCOMMERCE,
  logo: FluentcommerceLogo,
  url: 'https://fluentcommerce.com/',
},
{
  partner: PARTNER_BANNER_OPTIONS.MAGELLAN,
  logo: MagellanLogo,
  url: 'https://www.griddynamics.com/solutions/merchandising-experience-platform',
},
{
  partner: PARTNER_BANNER_OPTIONS.KIBO,
  logo: KiboLogo,
  url: 'https://kibocommerce.com/',
}, ];

export const partners = PARTNERS.map(partner =>
  partnersLogos.find(pl => pl.partner === partner)
);
